import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { YardStructureComponent } from './component/yard-structure.component';
import { StationGroupDetailsComponent } from './component/stationgroup-details/stationgroup-details.component';
import { StationSetComponent } from './component/stationset/stationset-component';
import { ColorPickerModule } from 'src/tmc-common/components/color-picker/color-picker.module';
import { BackupReferenceComponent } from './component/backup-reference/backup-reference.component';

@NgModule({
    declarations: [
        YardStructureComponent,
        StationGroupDetailsComponent,
        StationSetComponent,
        BackupReferenceComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        ColorPickerModule,
        CommonTranslationModule,
        ServiceResponseModule,
        CommonUIModule,
        ApplicationClientCommonModule
    ]
})
export class YardStructureModule { }
